import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalProvider, useGlobalContext } from './context/GlobalContext';
import { selfcareApi } from './services/SelfcareApiService';
import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';
import Home from './pages/Home';
import CardsApp from './pages/CardsApp';

import Help from './pages/Help';
import Data from './pages/Data';
import Error from './pages/Error';
import Logout from './pages/Logout';
import HelpFooter from './pages/HelpFooter';

function AppContent() {
  const {
    loading,
    ready,
    error,
    siteInfo,
    isAvailable,
    token
  } = useGlobalContext();

  React.useEffect(() => {
    if (siteInfo) {
      selfcareApi.setSiteInfo(siteInfo);
    }
  }, [siteInfo]);

  if (loading || !ready) {
    return <Loader />;
  }



  return (
    <body className="mainColor selfcare" >
      <div>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />

            <Route path="/home" element={<Home />} />
            <Route path="/help" element={<Help />} />
            <Route path="/help-page" element={<HelpFooter />} />
            <Route path="/data" element={<Data />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/error" element={<Error />} />
            <Route path="*" element={<Home />} />
            <Route path="/cards/:token" element={<CardsApp />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </body>
  );
}

function App() {
  return (
    <GlobalProvider>
      <Router>
        <AppContent />
      </Router>
    </GlobalProvider>
  );
}

export default App;